import React from 'react';
import { Link } from 'react-router-dom';
import { Sun, Mail, Phone, MapPin, Facebook, Linkedin, Instagram } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-white bg-blue-700">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img
                src="https://static.wixstatic.com/media/74b4ed_345609b0ca434880a008ab5385eb475e~mv2.png/v1/fill/w_634,h_171,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Logo_solar%20bull%202%20modification.png"
                alt="SolarBull Logo"
                className="h-10 brightness-0 invert" />

            </div>
            <p className="!text-sm mb-4 text-gray-300">Leading EPC company providing innovative solar solutions across India. Powering a sustainable future with clean energy.


            </p>
            <div className="flex space-x-3">
              <a href="https://www.facebook.com/solarbullindia/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="https://x.com/SolarBullEnergy" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                <svg className="h-4 w-4 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.858L1.214 2.25H8.08l4.26 5.631 5.905-5.631Zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://www.linkedin.com/company/solarbull/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="https://www.instagram.com/solarbull.energy/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-orange-400 text-sm transition-colors duration-300 inline-block hover:translate-x-1 transform">

                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-300 hover:text-orange-400 text-sm transition-colors duration-300 inline-block hover:translate-x-1 transform">

                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-300 hover:text-orange-400 text-sm transition-colors duration-300 inline-block hover:translate-x-1 transform">

                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/projects"
                  className="text-gray-300 hover:text-orange-400 text-sm transition-colors duration-300 inline-block hover:translate-x-1 transform">

                  Projects
                </Link>
              </li>
              <li>
                <Link
                  to="/calculator"
                  className="text-gray-300 hover:text-orange-400 text-sm transition-colors duration-300 inline-block hover:translate-x-1 transform">

                  Calculator
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-300 hover:text-orange-400 text-sm transition-colors duration-300 inline-block hover:translate-x-1 transform">

                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Our Services</h3>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-300">Industrial Solar EPC</li>
              <li className="text-gray-300">Commercial Solar</li>
              <li className="text-gray-300">Residential Solar</li>
              <li className="text-gray-300">PM SURYA GHAR</li>
              <li className="text-gray-300">Open Access Solar</li>
              <li className="text-gray-300">PM-KUSUM Projects</li>
              <li className="text-gray-300">Solar O&M</li>
              <li className="text-gray-300">PMC & Consultancy</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-orange-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-300">
                  8-1-301, Flat T3, Sa Re Ga Ma Apts<br />
                  (Above Axis Bank, 302, Shaikpet Rd,<br />
                  next to Karachi Bakery, Sabza Colony,<br />
                  Ambedkar Nagar, Toli Chowki,<br />
                  Hyderabad, Telangana 500104
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-orange-400 flex-shrink-0" />
                <a href="tel:+919876543210" className="text-gray-300 hover:text-orange-400 transition-colors duration-300">+91 9553746982</a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-orange-400 flex-shrink-0" />
                <a href="mailto:info@solarbull.in" className="text-gray-300 hover:text-orange-400 transition-colors duration-300">srini@solarbull.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 mt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} SolarBull. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-orange-400 transition-colors duration-300">
                Privacy Policy
              </Link>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors duration-300">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors duration-300">
                Sitemap
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};